<template>
  <div class="refuse-comment-dialog">
    <Modal v-model="visible" title="拒绝理由" width="30%" destroy-on-close>
      <div class="text">
        {{ reasonRefusal || '-' }}
      </div>
      <template #footer>
        <Button size="small" @click="close">返回</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      reasonRefusal: ''
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    open(row) {
      this.visible = true;
      this.reasonRefusal = row.reasonRefusal;
    },
    close() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.refuse-comment-dialog {
  .text {
    margin: 0 5px 20px;
    max-height: 200px;
    overflow-y: auto;
  }

  .button-wrapper {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
